import {
    PARENT_INCOME_EARNED_BY_BOTH,
    PARENT_MARITAL_STATUS_MARRIED,
    PARENT_MARITAL_STATUS_SINGLE
} from "../constants/MAGIC_NUMBERS";

//  Formula A tables

//  Table A1 - line 5a
export const tableA1a = (form, isParent) => {

    const medicareHIRateConstants = {
        'parentSingle':{
            'incomeSplit': 200000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'parentJoint':{
            'incomeSplit': 250000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'dependent': {
            'incomeSplit': 200000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        }
    }; //

    let parentSource = (parseInt(form.step3.parentMaritalStatus) === PARENT_MARITAL_STATUS_SINGLE)
        ? medicareHIRateConstants.parentSingle
        : medicareHIRateConstants.parentJoint;
    let dependentSource = medicareHIRateConstants.dependent;
    let parentIncomeLower, parentIncomeUpper;
    let dependentIncomeLower, dependentIncomeUpper;

    let dependentMultiplier = (!isParent) ? 1 : 0;
    let parentMultiplier = (isParent) ? 1: 0;

    if (parseInt(form.step3.parentAdjustedGrossIncome) > parentSource.incomeSplit) {
        parentIncomeLower = parentSource.incomeSplit;
        parentIncomeUpper = parseInt(form.step3.parentAdjustedGrossIncome) - parentSource.incomeSplit;
    } else {
        parentIncomeLower = parseInt(form.step3.parentAdjustedGrossIncome);
        parentIncomeUpper = 0.00;
    }

    if(parseInt(form.step3.studentAdjustedGrossIncome) > dependentSource.incomeSplit) {
        dependentIncomeLower = dependentSource.incomeSplit;
        dependentIncomeUpper = parseInt(form.step3.studentAdjustedGrossIncome) - dependentSource.incomeSplit;
    } else {
        dependentIncomeLower = parseInt(form.step3.studentAdjustedGrossIncome);
        dependentIncomeUpper = 0.00;
    }

    let result = Math.round(
        parentIncomeLower * parentSource.rateUpto * parentMultiplier +
        parentIncomeUpper * parentSource.rateOver * parentMultiplier +
        dependentIncomeLower * dependentSource.rateUpto * dependentMultiplier +
        dependentIncomeUpper * dependentSource.rateOver * dependentMultiplier);

    return Math.round(result);
}

//  Table A1 - line 5b
export const tableA1b = (form, isParent) => {

    const OASDIConstants = {
        'parentsSingleIncome': {
            'incomeMax': 147000,
            'percent': 0.062,
            'maximum': 9114
        },
        'parentsBothIncome': {
            'incomeMax': 294000,
            'percent': 0.062,
            'maximum': 18228
        },
        'dependent': {
            'incomeMax': 147000,
            'percent': 0.062,
            'maximum': 9114
        }
    };

    let parentSource = (
        parseInt(form.step3.parentIncomeEarnedBy) === PARENT_INCOME_EARNED_BY_BOTH ||
        parseInt(form.step3.parentMaritalStatus) === PARENT_MARITAL_STATUS_MARRIED
    )
        ? OASDIConstants.parentsBothIncome
        : OASDIConstants.parentsSingleIncome;
    let dependentSource = OASDIConstants.dependent;

    let dependentMultiplier = (!isParent) ? 1 : 0;
    let parentMultiplier = (isParent) ? 1 : 0;

    let parentIncome = parseInt(form.step3.parentAdjustedGrossIncome) + parseInt(form.step3.parentOtherIncome);
    let dependentIncome = parseInt(form.step3.studentAdjustedGrossIncome) + parseInt(form.step3.studentOtherIncome);

    let parentIncomeResult = (parentIncome > parentSource.incomeMax)
        ? parentSource.maximum
        : parentIncome * parentSource.percent;

    let dependentIncomeResult = (dependentIncome > dependentSource.incomeMax)
        ? dependentSource.maximum
        : dependentIncome * dependentSource.percent;

    let result =
        parentIncomeResult * parentMultiplier +
        dependentIncomeResult * dependentMultiplier;

    return Math.round(result);
}

//  Table A2
export const tableA2 = (familyCount) => {
    const allowanceList = {
        2: 27600,
        3: 34350,
        4: 42430,
        5: 50060,
        6: 58560
    };
    const additional = 6610;

    familyCount = parseInt(familyCount);
    if(familyCount < 2) {
        familyCount = 2;
    }

    if(allowanceList.hasOwnProperty(familyCount)) {
        return allowanceList[familyCount];
    }

    let intKeys = Object.keys(allowanceList).map((n)=>parseInt(n));
    let maxKey = Math.max(...intKeys);
    return allowanceList[maxKey] + (familyCount - maxKey) * additional;
}

//  Table A4
export const tableA4 = (parentAge) => {
    //  The SAI document has a table dealing with older parent age
    //  and including one/two parent count.
    //
    //  All values are 0, so returning 0.  In the event of a change,
    //  include the appropriate values and lookup here.
    return 0;
}

//  Table A5
export const tableA5 = (adjustedIncome) => {
    const rawValue = (adjustedIncome) => {
        if (adjustedIncome < -6820) {
            return -1500;
        }

        if (adjustedIncome <= 20600) {
            return 0.22 * adjustedIncome;
        }

        if (adjustedIncome <= 25800) {
            return 4532 + (0.25 * (adjustedIncome - 20600));
        }

        if (adjustedIncome <= 31000) {
            return 5832 + (0.29 * (adjustedIncome - 25800));
        }

        if (adjustedIncome <= 36300) {
            return 7340 + (0.34 * (adjustedIncome - 31000));
        }

        if (adjustedIncome <= 41500) {
            return 9142 + (0.40 * (adjustedIncome - 36300));
        }

        return 11222 + (0.47 * (adjustedIncome - 41500));
    }

    return Math.round(rawValue(adjustedIncome));
}
